/* eslint-disable import/prefer-default-export */
const Communication = Object.freeze({
    SMS: 'sms',
    MAIL: 'mail',
});

export { Communication };
